import angular from 'angular';
import 'angular-route';
import 'ngstorage';
import 'angular-click-outside';
import 'angular-promise-extras';
import '@cgross/angular-notify';

import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@cgross/angular-notify/dist/angular-notify.css';
import 'angulartics';

import angularticsGA from 'angulartics-google-analytics';

import frontendConfig from '../../config/frontend.config';
import root from './modules/root/';
import common from './modules/common/';
import account from './modules/account/';
import campaigns from './modules/campaigns/';
import tos from './modules/tos/';

import './assets/scss/base.scss';
/**
 * Load and merge configurations sent from the gateway in order to use them on the `appConstant`
 * constant.
 */
// eslint-disable-next-line angular/window-service
const appConstant = Object.assign({}, frontendConfig, (window.appConfig || {}));
/**
 * @ngdoc overview
 * @name contentCreatorAdmin
 * @description
 * This is the app main module, it loads all the other modules and dependencies.
 * If you are looking for the main component, that's on the `root` module.
 */
angular.module('contentCreatorAdmin', [
  'ngRoute',
  'ngStorage',
  'ngPromiseExtras',
  'tw.directives.clickOutside',
  'cgNotify',
  'angulartics',
  angularticsGA,
  root,
  common,
  account,
  campaigns,
  tos,
])
.constant('appConstant', appConstant);



// WEBPACK FOOTER //
// ./src/frontend/index.js